import React from 'react';
import { Link } from 'react-router-dom';

import "./promise.css"

export const promiseItems = (window.promiseItems) || [];

const Promise = () => {

    return (
        <section className="promise-section py-5 bg-light my-4 ">
            <div className="promise-container">
                <div className="heading-section"style={{maxWidth:"302px"}}>
                    <h2 className="heading-title uk-text-center p-0">Sunny Diamonds Promise</h2>
                    <div className="heading-icon mt-0">
                        <span className="hr-line">&nbsp;</span>
                        <span className="diamond-icon">&nbsp;</span>
                        <span className="hr-line">&nbsp;</span>
                    </div>
                </div>
                <div className="promise-content">
                    {promiseItems.map((item) => (
                        <Link key={item.label} to={`${process.env.PUBLIC_URL}${item.to}`}>
                            <img src={item.image} alt={item.label} />
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    )
};

export default Promise;
